import { LoginProfile } from 'src/types'
import { axios } from './axios'
// import { getFingerprint } from './fingerprint'

let cache: LoginProfile[] | null = null

export function getProfiles (fp: string | null, fn: (profiles: LoginProfile[]) => any): void {
  if (cache) {
    fn(cache)
  } else {
    if (fp) {
      axios.get('/login/profiles', {
        params: { fp },
        withCredentials: true
      })
        .then((res) => res.data)
        .then((data) => {
          cache = data
          fn(data)
        })
    } else {
      fn([])
    }
  }
}
